
import Vue from 'vue';
import EuButton from '../Button/Button.vue';
import EuCard from '../Card/Card.vue';
import GreenTick from '../../../Icons/GreenTick.vue';
import OrangeTick from '../../../Icons/OrangeTick.vue';
export default Vue.extend<any, any, any, any>({
  name: 'GeneralTopContent',
  data() {
    return {
      expand: false
    };
  },
  components: {
    EuButton,
    EuCard,
    GreenTick,
    OrangeTick
  },
  props: {
    /**
     * Set id for primary button
     */
    primaryId: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set id for secondary button
     */
    secondaryId: {
      type: [Number, String],
      default: ''
    },
    /**
     * Information shown on card
     */
    cardInformation: {
      type: Object,
      required: true
    },
    /**
     * Addition info before bottom content
     */
    additionInfo: {
      type: Object
    }
  },
  methods: {
    handleSecondaryButton(e: any) {
      /**
       * Method to click secondary button
       * @event second
       * @type {function}
       */
      this.$emit('second', e);
    },
    handlePrimaryButton(e: any) {
      /**
       * Method to click primary button
       * @event primary
       * @type {function}
       */
      this.$emit('primary', e);
    },
    handleEditValue(e: any) {
      /**
       * Method to click edit value on addition section
       * @event edit-value
       * @type {function}
       */
      this.$emit('edit-value', e);
    }
  }
});
